/**
 * Vista: Lista de Certificados de Venta
 * Formato: AMX-VTA-FR-09
 */

import ventasService from '../services/ventas.service.js';
import router from '../router/router.js';
import permisos from '../services/permissions.service.js';
import modal from '../utils/modal.js';

export default {
  async render() {
    return `
      <div class="card">
        <div class="card-header" style="display: flex; justify-content: space-between; align-items: center;">
          <h2 class="card-title">Certificados de Venta</h2>
          ${permisos.canCreate('certificados_venta') ? `
            <button class="btn btn-primary" onclick="router.navigate('/ventas/certificados/nuevo')">
              + Nuevo Certificado
            </button>
          ` : ''}
        </div>

        <!-- Filtros -->
        <div class="filters" style="display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 1rem; margin-bottom: 1.5rem;">
          <div class="form-group">
            <label class="form-label">Buscar</label>
            <input
              type="text"
              id="busqueda"
              class="form-input"
              placeholder="Num. Serie, Propietario, RFC..."
            />
          </div>

          <div class="form-group">
            <label class="form-label">Desde</label>
            <input type="date" id="fechaDesde" class="form-input" />
          </div>

          <div class="form-group">
            <label class="form-label">Hasta</label>
            <input type="date" id="fechaHasta" class="form-input" />
          </div>

          <div class="form-group" style="display: flex; align-items: flex-end;">
            <button class="btn btn-secondary" onclick="window.certificadosListView.limpiarFiltros()" style="width: 100%;">
              Limpiar Filtros
            </button>
          </div>
        </div>

        <!-- Tabla -->
        <div class="table-container">
          <table class="table">
            <thead>
              <tr>
                <th></th>
                <th>Num. Serie</th>
                <th class="tbl-hide-mobile">Fecha</th>
                <th class="tbl-hide-mobile">Modelo</th>
                <th class="tbl-hide-mobile">Propietario</th>
                <th class="tbl-hide-mobile">Lugar</th>
                <th class="tbl-hide-mobile">Teléfono</th>
                <th class="tbl-hide-mobile">Estado</th>
                <th class="tbl-hide-mobile">Acciones</th>
              </tr>
            </thead>
            <tbody id="certificadosTableBody">
              <tr>
                <td colspan="9" style="text-align: center; padding: 2rem;">
                  Cargando certificados...
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Paginación -->
        <div id="pagination" class="pagination" style="margin-top: 1rem;"></div>
      </div>
    `;
  },

  async afterRender() {
    if (!permisos.canView('certificados_venta')) {
      if (permisos.primeraRuta) { router.navigate(permisos.primeraRuta); }
      else { document.getElementById('content').innerHTML = '<div style="display:flex;justify-content:center;align-items:center;height:60vh;"><div style="text-align:center;color:var(--primary);"><h2>Acceso denegado</h2><p>No tienes permisos para acceder a este módulo.</p></div></div>'; }
      return;
    }
    window.certificadosListView = this;

    this.currentPage = 1;
    this.limit = 10;
    this.filters = {};

    // Event listeners
    document.getElementById('busqueda').addEventListener('input', (e) => {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.filters.search = e.target.value;
        this.currentPage = 1;
        this.cargarCertificados();
      }, 500);
    });

    document.getElementById('fechaDesde').addEventListener('change', (e) => {
      this.filters.fecha_desde = e.target.value;
      this.currentPage = 1;
      this.cargarCertificados();
    });

    document.getElementById('fechaHasta').addEventListener('change', (e) => {
      this.filters.fecha_hasta = e.target.value;
      this.currentPage = 1;
      this.cargarCertificados();
    });

    await this.cargarCertificados();
  },

  async cargarCertificados() {
    try {
      const params = {
        page: this.currentPage,
        limit: this.limit,
        ...this.filters
      };

      const response = await ventasService.listarCertificados(params);
      // La respuesta viene como { data: { certificados: [], pagination: {} } }
      const data = response.data || response;
      const certificados = data.certificados || [];
      const pagination = data.pagination || { page: 1, totalPages: 1, total: 0 };

      this.renderCertificados(Array.isArray(certificados) ? certificados : []);
      this.renderPaginacion(pagination);
    } catch (error) {
      toast.error('Error al cargar certificados');
      console.error('Error:', error);
      this.renderCertificados([]);
    }
  },

  renderCertificados(certificados) {
    const tbody = document.getElementById('certificadosTableBody');

    if (!certificados || certificados.length === 0) {
      tbody.innerHTML = `
        <tr>
          <td colspan="9" style="text-align: center; padding: 2rem;">
            No se encontraron certificados
          </td>
        </tr>
      `;
      return;
    }

    const fechaFmt = (f) => f ? new Date(f).toLocaleDateString('es-MX') : '-';
    const estadoBadge = (c) => `<span class="badge ${c.completada ? 'badge-success' : 'badge-warning'}">${c.completada ? 'Completada' : 'Pendiente'}</span>`;
    const acciones = (c) => c.completada
      ? (permisos.canView('certificados_venta') ? `<button class="btn btn-sm btn-primary" onclick="window.certificadosListView.verDetalle(${c.id})">Ver</button>` : '')
      : `${permisos.canEdit('certificados_venta') ? `<button class="btn btn-sm btn-primary" onclick="window.certificadosListView.verDetalle(${c.id})">Editar</button>` : ''}
         ${permisos.canDelete('certificados_venta') ? `<button class="btn btn-sm btn-danger" onclick="window.certificadosListView.eliminarCertificado(${c.id})">Eliminar</button>` : ''}`;

    tbody.innerHTML = certificados.map(c => `
      <tr>
        <td>
          <button class="tbl-expand-btn" onclick="window.certificadosListView.toggleRow(${c.id})">&#9654;</button>
        </td>
        <td><strong>${c.num_serie}</strong></td>
        <td class="tbl-hide-mobile">${fechaFmt(c.fecha)}</td>
        <td class="tbl-hide-mobile">${c.modelo}</td>
        <td class="tbl-hide-mobile">${c.propietario}</td>
        <td class="tbl-hide-mobile">${c.lugar}</td>
        <td class="tbl-hide-mobile">${c.telefono}</td>
        <td class="tbl-hide-mobile">${estadoBadge(c)}</td>
        <td class="tbl-hide-mobile">
          <div style="display: flex; gap: 0.5rem;">${acciones(c)}</div>
        </td>
      </tr>
      <tr class="tbl-detail-row" id="detail-cert-${c.id}">
        <td colspan="9" class="tbl-detail-cell">
          <dl class="tbl-detail-grid">
            <dt>Fecha</dt><dd>${fechaFmt(c.fecha)}</dd>
            <dt>Modelo</dt><dd>${c.modelo}</dd>
            <dt>Propietario</dt><dd>${c.propietario}</dd>
            <dt>Lugar</dt><dd>${c.lugar}</dd>
            <dt>Teléfono</dt><dd>${c.telefono}</dd>
            <dt>Estado</dt><dd>${estadoBadge(c)}</dd>
          </dl>
          <div style="margin-top: var(--spacing-sm); display: flex; gap: var(--spacing-xs);">
            ${acciones(c)}
          </div>
        </td>
      </tr>
    `).join('');
  },

  renderPaginacion(pagination) {
    const container = document.getElementById('pagination');
    const { page, totalPages } = pagination;

    if (totalPages <= 1) {
      container.innerHTML = '';
      return;
    }

    let html = '<div style="display: flex; gap: 0.5rem; justify-content: center; align-items: center;">';

    html += `
      <button
        class="btn btn-sm btn-secondary"
        onclick="window.certificadosListView.cambiarPagina(${page - 1})"
        ${page === 1 ? 'disabled' : ''}
      >
        Anterior
      </button>
    `;

    for (let i = 1; i <= totalPages; i++) {
      if (i === page) {
        html += `<button class="btn btn-sm btn-primary" disabled>${i}</button>`;
      } else if (i === 1 || i === totalPages || (i >= page - 2 && i <= page + 2)) {
        html += `
          <button
            class="btn btn-sm btn-secondary"
            onclick="window.certificadosListView.cambiarPagina(${i})"
          >
            ${i}
          </button>
        `;
      } else if (i === page - 3 || i === page + 3) {
        html += '<span>...</span>';
      }
    }

    html += `
      <button
        class="btn btn-sm btn-secondary"
        onclick="window.certificadosListView.cambiarPagina(${page + 1})"
        ${page === totalPages ? 'disabled' : ''}
      >
        Siguiente
      </button>
    `;

    html += '</div>';
    container.innerHTML = html;
  },

  cambiarPagina(page) {
    this.currentPage = page;
    this.cargarCertificados();
  },

  limpiarFiltros() {
    document.getElementById('busqueda').value = '';
    document.getElementById('fechaDesde').value = '';
    document.getElementById('fechaHasta').value = '';
    this.filters = {};
    this.currentPage = 1;
    this.cargarCertificados();
  },

  toggleRow(id) {
    const detailRow = document.getElementById(`detail-cert-${id}`);
    const btn = detailRow?.previousElementSibling?.querySelector('.tbl-expand-btn');
    if (detailRow) {
      detailRow.classList.toggle('open');
      btn?.classList.toggle('open');
    }
  },

  verDetalle(id) {
    router.navigate(`/ventas/certificados/${id}`);
  },

  async eliminarCertificado(id) {
    modal.confirm(
      'Confirmar eliminación',
      `¿Está seguro de eliminar este certificado? Esta acción no se puede deshacer.`,
      async () => {
        try {
          await ventasService.eliminarCertificado(id);
          toast.success('Certificado eliminado exitosamente');
          this.cargarCertificados();
        } catch (error) {
          toast.error(error.message || 'Error al eliminar certificado');
          console.error(error);
        }
      }
    );
  }
};
